export const VERIFY_EMAIL = 'VERIFY_EMAIL';
export const VERIFY_EMAIL_DONE = 'VERIFY_EMAIL_DONE';
export const VERIFY_EMAIL_ERR = 'VERIFY_EMAIL_ERR';
export const RESET_EMAIL_VERIFICATION = 'RESET_EMAIL_VERIFICATION';
//# sourceMappingURL=actionTypes.js.map